import { type FC, type SVGProps } from 'react';

import cls from 'classnames';

import { skeletonStyles } from './Skeleton.style';

interface Props {
	svgClassName?: string;
	svg: FC<SVGProps<SVGSVGElement>>;
}

export const SkeletonSVG: React.FC<Props> = ({ svgClassName, svg }) => {
	const { classes } = skeletonStyles();
	const SkeletonSVG = svg;
	return (
		<div className={classes.container}>
			<div className={classes.animation} />
			<SkeletonSVG width={'100%'} height={'100%'} className={cls(classes.icon, svgClassName)} />
		</div>
	);
};
